import { useEffect } from 'react';
import { emitToast } from '../../events/error/errorEventBus';
import { useCartNotices } from '../../hooks/cart/useCartNotices';

/**
 * CartNoticeListener 这是一个纯逻辑组件（无渲染）。
 * 它监听 cartNotices 状态，
 * 当有新的通知产生时，将其转换为全局 Toast 提示并清理 Store。
 */
export function CartNoticeListener() {
    const { notices, clearNotices } = useCartNotices();

    useEffect(() => {
        if (notices && notices.length > 0) {
            // 遍历所有通知并发出 Toast
            notices.forEach((notice) => {
                emitToast({
                    type: 'info',
                    message: notice.message
                });
            });

            // 延迟清理，避免在渲染过程中调用 set
            const timer = setTimeout(() => {
                clearNotices();
            }, 0);

            return () => clearTimeout(timer);
        }
    }, [notices, clearNotices]);

    return null;
}
